import React from 'react';
import { Form } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import validate from '../../../../../utils/validate';
import AgentForm from '../agent-form/AgentForm';
import { agentFormYopValidation } from '../agent-form/validation';
import FormTitle from '../form-title/FormTitle';
import { addSystemAgent } from '../../../../../redux/settings/id8/id8SettingsActions';

function CreateAgent() {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const createAgentInitialValues = {
    name: '',
    instructions: '',
  };

  const handleCreateAgent = async (values) => {
    await dispatch(addSystemAgent(values));

    navigate('/settings/id8');
  };

  return (
    <>
      <FormTitle title={t('addNewAgent')} />

      <Form
        initialValues={createAgentInitialValues}
        onSubmit={handleCreateAgent}
        validate={(values) => validate(values, agentFormYopValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <AgentForm handleSubmit={handleSubmit} />}
      />
    </>
  );
}

export default CreateAgent;
